// extracted by mini-css-extract-plugin
export default {"error":"SupportContactForm_error__BLCXI","placeHolderShimmer":"SupportContactForm_placeHolderShimmer__9fzgy"};